var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Language & Communication"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Languages Spoken"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            " " +
              _vm._s(
                (_vm.data.communication_languages_spoken || []).join(", ") ||
                  "N/A"
              ) +
              " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Preferred Language"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.preferred_language ? _vm.data.preferred_language : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Interpreter Needed"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.interpreter_needed ? _vm.data.interpreter_needed : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Communication Style"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.preferred_communication_style
                ? _vm.data.preferred_communication_style
                : "N/A"
            )
          ),
        ]),
      ]),
      _vm.data.visual_communication_style
        ? _c("div", { staticClass: "flex gap-8" }, [
            _c(
              "div",
              { staticClass: "flex-1 text-16 font-medium minWContent" },
              [_vm._v("Visual Communication Style")]
            ),
            _c(
              "div",
              { staticClass: "flex-2 text-16 font-medium text-gray-400" },
              [
                _vm._v(
                  _vm._s(_vm.getStyle(_vm.data.visual_communication_style))
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }